<dgx-cms-dynamic-component-outlet
  [area]="area"
></dgx-cms-dynamic-component-outlet>
